import React from "react";
import ItineraryAppointment from "./ItineraryAppointment";
import LinkAppointment from "./LinkAppointment";
import { canLinkAppointment, getId } from "./utils";
import { AppointmentPreviewPlanner } from "components/PreviewPanel/Appointment/AppointmentPreview";
import { itinerarySidebarQueryKey } from "./app";
import { useQueryClient } from "@tanstack/react-query";

interface Props {
  onHoverOver: (appointment: server.dto.PlannerAppointment) => void
  hoveringOver: server.dto.PlannerAppointment
  appointment: server.dto.PlannerAppointment
  showId: number
  canCreateNewAppointment: boolean
  linkedFlightSegmentIds: number[]
  linkedGroundTransportIds: number[]
  linkedTrainSegmentIds: number[]

  toggleLinked: (appointment: server.dto.PlannerAppointment) => void

  canLinkUnlinkTravel: boolean
}

const ItineraryAppointmentRow = (props: Props) => {
  const isHighlighted = (appointment: server.dto.PlannerAppointment) => {
    if (!props.hoveringOver || !appointment) {
      return false;
    }

    return getId(appointment) === getId(props.hoveringOver);
  };

  const isActive = (appointment: server.dto.PlannerAppointment) => {
    if (!appointment || !props.showId) {
      return false;
    }

    return props.showId === appointment.showId;
  };

  const queryClient = useQueryClient();

  const onChange = () => {
    queryClient.invalidateQueries([itinerarySidebarQueryKey]);
  }

  return <>
    <td
      onMouseEnter={() => { props.onHoverOver(props.appointment); }}
      onMouseLeave={() => { props.onHoverOver(null); }}
      style={{ cursor: "pointer" }}
    >
      <AppointmentPreviewPlanner
        appointment={props.appointment}
        onChange={onChange}
      >
        <ItineraryAppointment
          highlighted={isHighlighted(props.appointment)}
          active={isActive(props.appointment)}
          appointment={props.appointment}
        />
      </AppointmentPreviewPlanner>
    </td>
    {props.canCreateNewAppointment && <>
      {!canLinkAppointment(props.canLinkUnlinkTravel, props.showId, props.appointment) &&
        <td style={{ width: 30 }}></td>
      }
      {canLinkAppointment(props.canLinkUnlinkTravel, props.showId, props.appointment) && <LinkAppointment
        appointment={props.appointment}
        linkedFlightSegmentIds={props.linkedFlightSegmentIds}
        linkedGroundTransportIds={props.linkedGroundTransportIds}
        linkedTrainSegmentIds={props.linkedTrainSegmentIds}
        onToggleLinked={() => { props.toggleLinked(props.appointment); }}
      />}
    </>}
  </>;
};

export default ItineraryAppointmentRow;
